jQuery( document ).ready(function() {

    $('.product-information .accordion accordion-custom:nth-child(1) rte-formatter').each(function(){
      var $content = $(this);

      // Add fade effect at bottom
      $content.append('<div class="rte-fade"></div>');

      // Add Read More / Less toggle button after each content block
      var $toggleBtn = $('<div class="read-toggle-btn">Læs mere</div>');
      $content.after($toggleBtn);

      // Toggle functionality
      $toggleBtn.on('click', function(){
        $content.toggleClass('expanded');
        $(this).text($content.hasClass('expanded') ? 'Læs mindre' : 'Læs mere');
      });
    });

});